import { css, Global } from '@emotion/react';
import { vars } from '@teamsparta/stack-tokens';

const DesignSystemCss = () => {
  return <Global styles={style} />;
};

const style = css`
  input:focus {
    outline: none;
  }

  textarea {
    border-radius: 8px;
    border: 1px solid ${vars.neutral[20]};
  }

  textarea:placeholder-shown {
    color: ${vars.neutral[50]};
  }
  textarea:focus {
    border: 1px solid ${vars.neutral[80]};
  }
`;

export default DesignSystemCss;
